<template>
  <div class="patternCard">
    <div class="patternCardHeader">
      <img
        src="/static/img/dotsix.png"
        alt
        class="responsive-img handleMove"
        style="height: 20px"
      />
    </div>
    <div
      :class="
        !['หน้าถัดไป'].includes(value.questiontype) ? 'patternCardBody' : 'patternCardBody border0'
      "
    >
      <v-layout
        row
        wrap
        :class="
          !['หัวข้อ', 'บทความ', 'หน้าถัดไป', 'ที่อยู่'].includes(value.questiontype)
            ? 'patternOption'
            : !['บทความ', 'หน้าถัดไป', 'ที่อยู่'].includes(value.questiontype)
            ? 'patternTopicOption'
            : ['หน้าถัดไป'].includes(value.questiontype)
            ? 'patternNextPageOption'
            : 'patternSingleOption'
        "
      >
        <v-flex xs12 class="mb-3">
          <div style="display: flex; align-items: center">
            <div
              v-if="value.questiontype != 'หน้าถัดไป'"
              class="form-control"
              style="width: 95%; display: flex;"
              :class="{ 'has-error': errors.has(value.questiontype + dataindex) }"
            >
              <template v-if="value.questiontype == 'บทความ'">
                <textarea
                  :name="'คำถาม' + dataindex"
                  :data-vv-as="'คำถาม'"
                  v-validate="'required'"
                  :value="value.name"
                  @input="update('name', $event.target.value)"
                  placeholder="กรอกบทความ"
                  type="text"
                  class="rsu mb-0"
                  rows="6"
                  style="height: auto !important;padding: 12px !important;margin: 0;resize: none;"
                />
              </template>
              <template v-else>
                <img
                  v-if="value.questiontype == 'หัวข้อ'"
                  :src="`/static/img/assets/menuIcons/${typeIcon('หัวข้อ')}.svg`"
                  alt
                  class="responsive-img mr-2"
                />
                <input
                  :name="'คำถาม' + dataindex"
                  :data-vv-as="value.questiontype"
                  v-validate="'required'"
                  :value="value.name"
                  @input="update('name', $event.target.value)"
                  :placeholder="`กรอก${value.questiontype}`"
                  type="text"
                  :class="
                    `depainput rsu mb-0 ${
                      ['หัวข้อ'].includes(value.questiontype) ? 'questiontypeTopicInput' : null
                    }`
                  "
                />
              </template>
            </div>
            <v-btn
              v-if="!['หน้าถัดไป'].includes(value.questiontype)"
              @click="$emit('ondelete')"
              icon
              class="ma-0 ml-3"
            >
              <img src="/static/img/delete.png" alt class="responsive-img" style="height: 20px" />
            </v-btn>
          </div>
          <div>
            <span class="text-error" v-if="errors.has('คำถาม' + dataindex)">{{
              errors.first('คำถาม' + dataindex)
            }}</span>
          </div>
        </v-flex>
        <v-flex
          :xs6="!['หน้าถัดไป'].includes(value.questiontype)"
          :xs12="['หน้าถัดไป'].includes(value.questiontype)"
          v-show="!['หัวข้อ'].includes(value.questiontype)"
          style="display: flex;"
        >
          <v-menu>
            <template #activator="{ on: menu }">
              <div style="cursor: pointer;display:flex;width: 95%;" v-on="menu">
                <div style="position: relative" class="form-control d-flex align-center w-100">
                  <div style="position: absolute;left: 12px;">
                    <img
                      :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
                      alt
                      class="responsive-img"
                    />
                  </div>
                  <input
                    :value="value.questiontype"
                    readonly
                    type="text"
                    class="depainput rsu"
                    style="padding-left: 40px !important; cursor: pointer;color: #152d53;"
                  />
                  <i
                    style="color: grey; position: absolute; right: 10px; top: 10px"
                    class="fas fa-chevron-down"
                  ></i>
                </div>
              </div>
            </template>
            <v-list style="max-height: 60vh; overflow: auto">
              <v-list-tile
                class="rsu"
                v-for="(item, index) in optionsStatus"
                :key="index"
                @click="selectOptionStatus(item)"
              >
                <v-list-tile-title>
                  <div
                    style="color: #152d53;display: flex;justify-content: flex-start;align-items: center;"
                  >
                    <img
                      :src="`/static/img/assets/menuIcons/${typeIcon(item)}.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 20px;"
                    />
                    {{ item | filterStatus }}
                  </div>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn
            v-if="['หน้าถัดไป'].includes(value.questiontype)"
            @click="$emit('ondelete')"
            icon
            class="ma-0 ml-3"
          >
            <img
              src="/static/img/whitedelete.svg"
              alt
              class="responsive-img"
              style="height: 15px"
            />
          </v-btn>
        </v-flex>
        <v-flex xs6>
          <div class="d-flex" v-if="!['หน้าถัดไป'].includes(value.questiontype)">
            <v-checkbox
              label="ซ่อนจากสมาชิก"
              v-model="value.hideFromMember"
              color="primary"
              class="mt-0 ml-2 optionCheckBox"
            ></v-checkbox>
            <v-checkbox
              v-if="
                !['หัวข้อ', 'บทความ', 'หน้าถัดไป', 'ตัวอย่างไฟล์', 'แนบลิงก์'].includes(
                  value.questiontype
                )
              "
              v-model="value.isRequired"
              @change="update('isRequired', $event)"
              class="mt-0 optionCheckBox"
              color="primary"
              label="จำเป็น"
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="patternDetails"
        v-if="
          ![
            'หัวข้อ',
            'บทความ',
            'หน้าถัดไป',
            'ที่อยู่',
            'ช่องกรอกลิงก์',
            'รายการผลิตภัณฑ์'
          ].includes(value.questiontype)
        "
      >
        <v-flex xs10 v-if="['ข้อความ'].includes(value.questiontype)">
          <div class="input-ans">
            <Typography h5 semiBold color="darkGrey" class="mb-2" label="คำตอบเริ่มต้น" />
            <DropdownMenu
              v-model="value.Options"
              :options="defaultAnswerOptions"
              :textLabel="'label'"
              :textValue="'value'"
            >
              <div style="position: relative" class="form-control">
                <input
                  :value="defaultAnswerFiltered"
                  placeholder="(ไม่มี)"
                  type="text"
                  class="option-input rsu"
                  style="cursor: pointer"
                />
              </div>
            </DropdownMenu>
          </div>
        </v-flex>
        <v-flex xs10 v-if="['รูปภาพ'].includes(value.questiontype)">
          <div
            style="width: 100%"
            class="form-control"
            :class="{ 'has-error': errors.has('ไฟล์ภาพ' + dataindex) }"
          >
            <uploadfile
              @input="onUploadedImg($event)"
              :ref="'sampleImg' + dataindex"
              :index="dataindex"
              v-validate="'required'"
              :name="'ไฟล์ภาพ' + dataindex"
              v-model="value.imgFile"
            ></uploadfile>
            <span class="text-error" v-if="errors.has('ไฟล์ภาพ' + dataindex)">{{
              errors.first('ไฟล์ภาพ' + dataindex)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 v-if="['ตาราง'].includes(value.questiontype)">
          <v-layout row wrap class="ma-0">
            <v-flex xs12 v-if="!value.formTable.data.length">
              <v-layout row wrap class="ma-0">
                <v-flex xs5>
                  <div class="form-control pr-2">
                    <Typography h5 semiBold color="color-darkGrey" class="mb-2" label="จำนวนแถว" />
                    <input
                      v-model="rowCount"
                      type="number"
                      min="1"
                      placeholder=""
                      class="option-input rsu"
                    />
                  </div>
                </v-flex>
                <v-flex xs5>
                  <div class="form-control pl-2">
                    <Typography
                      h5
                      semiBold
                      color="color-darkGrey"
                      class="mb-2"
                      label="จำนวนคอลัมน์"
                    />
                    <input
                      v-model="columnCount"
                      type="number"
                      min="1"
                      placeholder=""
                      class="option-input rsu"
                    />
                  </div>
                </v-flex>
                <v-flex xs2 style="display: flex;align-items: flex-end;margin: 0px 0px 8px;">
                  <div class="w-100 form-control pl-3">
                    <v-btn
                      :disabled="!(this.rowCount && this.columnCount)"
                      class="w-100 rsu ma-0"
                      @click="generateTable"
                      round
                      outline
                      color="primary"
                    >
                      สร้าง
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-if="value.formTable.data.length">
              <template>
                <v-layout row wrap class="ma-0">
                  <div class="generate-table-container">
                    <table class="form-generate-table">
                      <thead>
                        <tr>
                          <th
                            v-for="(header, headerIndex) in value.formTable.data[0]"
                            :key="headerIndex"
                            :class="
                              !value.formTable.viewColumn && headerIndex === 0 ? 'd-ghost' : ''
                            "
                          >
                            <v-text-field
                              v-if="headerIndex === 0"
                              solo
                              v-model="value.formTable.data[0][headerIndex]"
                              class="editTextTable firstItem rsu"
                              single-line
                              :readonly="!value.formTable.viewColumn"
                            >
                              <template v-slot:append>
                                <img
                                  v-if="value.formTable.viewColumn"
                                  :src="`/static/icon/${'viewSvg'}.svg`"
                                  alt
                                  class="responsive-img table-ico"
                                  @click="setViewTableColumn"
                                />
                                <img
                                  v-if="!value.formTable.viewColumn"
                                  :src="`/static/icon/${'notViewSvg'}.svg`"
                                  alt
                                  class="responsive-img table-ico"
                                  @click="setViewTableColumn"
                                />
                              </template>
                            </v-text-field>
                            <v-text-field
                              v-if="headerIndex != 0"
                              solo
                              v-model="value.formTable.data[0][headerIndex]"
                              class="editTextTable rsu"
                              single-line
                            >
                              <template v-slot:append>
                                <img
                                  v-if="value.formTable.data[0].length > 2"
                                  :src="`/static/icon/${'deleteSvg'}.svg`"
                                  alt
                                  class="responsive-img table-ico"
                                  @click="deleteColumn(headerIndex)"
                                />
                              </template>
                            </v-text-field>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in value.formTable.data.slice(1)"
                          :key="rowIndex"
                        >
                          <td
                            v-for="(column, columnIndex) in row"
                            :key="columnIndex"
                            :class="
                              !value.formTable.viewColumn && columnIndex === 0 ? 'd-ghost' : ''
                            "
                          >
                            <v-text-field
                              v-if="columnIndex === 0"
                              solo
                              v-model="value.formTable.data[rowIndex + 1][0]"
                              class="editTextTable rsu"
                              single-line
                              :readonly="!value.formTable.viewColumn"
                            >
                              <template v-slot:append>
                                <img
                                  v-if="value.formTable.data.length > 2"
                                  :src="`/static/icon/${'deleteSvg'}.svg`"
                                  alt
                                  class="responsive-img table-ico"
                                  @click="deleteRow(rowIndex + 1)"
                                />
                              </template>
                            </v-text-field>
                            <v-text-field
                              v-else
                              solo
                              v-model="value.formTable.data[rowIndex + 1][columnIndex]"
                              class="editTextTable rsu"
                              single-line
                              readonly
                            >
                            </v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-layout>
                <v-layout row wrap class="ma-0 mt-2">
                  <v-btn
                    style="width: 150px;"
                    class="mx-0 rsu mr-2"
                    round
                    outline
                    color="primary"
                    :loading="loading"
                    @click="addRow"
                  >
                    <img
                      :src="`/static/img/plusfill.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 20px;"
                    />
                    เพิ่มแถว
                  </v-btn>
                  <v-btn
                    style="width: 150px;"
                    class="mx-0 rsu"
                    round
                    outline
                    color="primary"
                    :loading="loading"
                    @click="addColumn"
                  >
                    <img
                      :src="`/static/img/plusfill.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 20px;"
                    />
                    เพิ่มคอลัมน์
                  </v-btn>
                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6 v-if="['ตัวเลข'].includes(value.questiontype)">
          <div>
            <Typography h5 semiBold color="color-darkGrey" class="mb-2" label="กำหนดหลักตัวเลข" />
            <div
              style="position: relative"
              class="form-control"
              :class="{ 'has-error': errors.has('กำหนดหลักตัวเลข' + dataindex) }"
            >
              <input
                @input="update('digitPosition', $event.target.value)"
                :value="value.digitPosition"
                placeholder="กำหนดหลักตัวเลข"
                type="text"
                class="depainput rsu"
                maxlength="2"
                max="20"
                min="1"
                @keypress="isNumber($event)"
                :name="'กำหนดหลักตัวเลข' + dataindex"
                data-vv-as="กำหนดหลักตัวเลข"
                v-validate="'required|numeric|max:3|max_value:20|min_value:1'"
              />
              <span class="text-error" v-if="errors.has('กำหนดหลักตัวเลข' + dataindex)">{{
                errors.first('กำหนดหลักตัวเลข' + dataindex)
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs10 v-if="['แนบลิงก์'].includes(value.questiontype)">
          <div>
            <Typography h5 semiBold color="color-darkGrey" class="mb-2" label="URL" />
            <div
              style="position: relative"
              class="form-control"
              :class="{ 'has-error': errors.has('URL' + dataindex) }"
            >
              <input
                @input="update('URL', $event.target.value)"
                :name="'URL' + dataindex"
                :value="value.URL"
                placeholder="http://www.example.com"
                type="text"
                class="depainput rsu"
                data-vv-as="URL"
                v-validate="'isUrl'"
              />
              <span class="text-error" v-if="errors.has('URL' + dataindex)">{{
                errors.first('URL' + dataindex)
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs6 v-if="['ตัวอย่างไฟล์'].includes(value.questiontype)">
          <div>
            <Typography
              h5
              semiBold
              class="mb-2"
              color="color-darkGrey"
              label="ตั้งชื่อตัวอย่างไฟล์"
            />
            <div
              style="position: relative"
              class="form-control"
              :class="{ 'has-error': errors.has('ตั้งชื่อตัวอย่างไฟล์' + dataindex) }"
            >
              <input
                @input="update('filename', $event.target.value)"
                :value="value.filename"
                placeholder=""
                type="text"
                class="depainput rsu "
                maxlength="20"
                :name="'ตั้งชื่อตัวอย่างไฟล์' + dataindex"
                data-vv-as="ตั้งชื่อตัวอย่างไฟล์"
                v-validate="'required'"
              />
              <span class="text-error" v-if="errors.has('ตั้งชื่อตัวอย่างไฟล์' + dataindex)">{{
                errors.first('ตั้งชื่อตัวอย่างไฟล์' + dataindex)
              }}</span>
            </div>
            <uploadalltype
              ref="samplefile"
              v-model="value.fileurl"
              @onUploaded="onUploadedFile($event)"
              v-validate="'required'"
              :multiple="false"
              :showOnlyButton="true"
            >
              <template v-slot="{ loading }">
                <v-btn style="width: 142px;" class="mx-0 rsu" round outline color="primary" :loading="loading">
                  <img
                    :src="`/static/img/plusfill.svg`"
                    alt
                    class="responsive-img mr-2"
                    style="height: 20px;"
                  />
                  {{ $t('select file to upload') }}
                </v-btn>
                <Typography
                  h7
                  semiBold
                  color="color-lightMediumGrey"
                  :label="$t('upload file size: {size}MB', { size: 10 })"
                />
              </template>
            </uploadalltype>
          </div>
        </v-flex>
        <v-flex
          v-if="
            ![
              'ข้อความ',
              'อัปโหลดไฟล์',
              'อัปโหลดลายเซ็น',
              'หัวข้อ',
              'บทความ',
              'หน้าถัดไป',
              'วัน/เวลา',
              'ที่อยู่',
              'ตัวเลข',
              'แนบลิงก์',
              'ตัวอย่างไฟล์',
              'รูปภาพ',
              'ตาราง'
            ].includes(value.questiontype)
          "
          xs12
          class="pr-0 rsu"
        >
          <div
            v-for="(item, k) in value.fields"
            :key="k"
            class="0"
            style="display: flex; align-items: center"
          >
            <div style="width: 100%;" class="rsu">
              <v-layout class="mb-2">
                <v-flex>
                  <v-text-field
                    :name="'ตัวเลือก' + dataindex + k"
                    :data-vv-as="'ตัวเลือก'"
                    :placeholder="'ตัวเลือก ' + (k + 1)"
                    :error-messages="errors.first('ตัวเลือก' + dataindex + k)"
                    v-validate="'required'"
                    v-model="value.fields[k].label"
                    class="option-input rsu"
                    single-line
                    append-icon="mdi-close"
                    @click:append="deleteItem(k)"
                    @click="checkFocus(k)"
                  >
                    <template v-slot:prepend>
                      <img
                        :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
                        alt
                        class="responsive-img mr-2"
                        style="height: 20px;"
                      />
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex
                  shrink
                  class="pl-2"
                  style="display: flex;align-items: center;"
                  v-if="
                    ['ช่องทำเครื่องหมาย', 'หลายตัวเลือก', 'เลื่อนลง'].includes(value.questiontype)
                  "
                >
                  <v-checkbox
                    class="mt-0 checkDf"
                    label="Default"
                    v-model="value.defaultOptions"
                    :multiple="['ช่องทำเครื่องหมาย'].includes(value.questiontype)"
                    :value="value.fields[k].label"
                    color="primary"
                    @input="update('defaultOptions', $event.target.value)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <div v-if="['ช่องทำเครื่องหมาย', 'หลายตัวเลือก'].includes(value.questiontype)">
                <draggable
                  v-model="value.fields[k].subquestion"
                  @start="drag = true"
                  @end="dropSubFormItem"
                >
                  <div
                    :key="dataindex + k + '' + index"
                    v-for="(form, index) in value.fields[k].subquestion"
                  >
                    <FormitemSubquestion
                      class="py-1"
                      :formlength="value.fields[k].subquestion.length"
                      :dataindex="index"
                      @ondelete="ondelete(index, k)"
                      v-model="value.fields[k].subquestion[index]"
                    ></FormitemSubquestion>
                  </div>
                </draggable>
                <div v-if="value.fields[k].focus">
                  <v-flex xs12 class="mb-2" style="padding-left: 12px;">
                    <v-btn class="rsu mx-0 icoBtn" round @click="addsubquestion(k, 'หัวข้อ')">
                      <img
                        src="/static/img/datalist.png"
                        alt
                        class="responsive-img mr-2"
                        style="height: 15px"
                      />
                      เพิ่มหัวข้อ
                    </v-btn>
                    <v-btn class="rsu mx-0 icoBtn" round @click="addsubquestion(k, '')">
                      <img
                        src="/static/img/Add.png"
                        alt
                        class="responsive-img mr-2"
                        style="height: 15px"
                      />
                      เพิ่มรูปแบบ
                    </v-btn>
                  </v-flex>
                  <!-- <v-btn class="rsu" @click="addsubquestion(k)" small color="primary"
                    >เพิ่มคำถาม</v-btn
                  > -->
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <img
              :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
              alt
              class="responsive-img mr-2"
              style="height: 20px;"
            />
            <input
              @keyup.enter="onBlurMorefield"
              @blur="onBlurMorefield"
              v-model="morefield_input"
              placeholder="เพิ่มตัวเลือกหรืออื่นๆ"
              class="borderInput rsu mb-0"
              style="width: 75.3%;"
            />
          </div>
        </v-flex>
        <v-flex xs12 v-if="['อัปโหลดลายเซ็น', 'อัปโหลดไฟล์'].includes(value.questiontype)">
          <div class="checkUpload">
            <v-checkbox
              color="primary"
              v-model="value.isMultiple"
              label="Multiple File"
            ></v-checkbox>
          </div>
        </v-flex>
        <v-flex xs12 v-if="value.questiontype == 'วัน/เวลา'">
          <Typography h5 semiBold color="darkGrey" class="mb-2" label="รูปแบบคำตอบ" />
          <div class="form-control" style="width: 47.4%;">
            <DropdownMenu
              v-model="value.Options"
              :options="defaultDateOptions"
              :textLabel="'label'"
              :textValue="'value'"
            >
              <input
                placeholder="เลือกรูปแบบ"
                type="text"
                class="depainput rsu mb-0"
                :value="defaultDateFiltered"
              />
            </DropdownMenu>
            <!-- <v-radio-group v-model="value.Options" row>
              <v-radio color="primary" value="all" label="Date&Time"></v-radio>
              <v-radio color="primary" value="date" label="Date"></v-radio>
              <v-radio color="primary" value="time" label="Time"></v-radio>
            </v-radio-group> -->
          </div>
        </v-flex>
        <!-- <v-flex xs12 v-if="['วัน/เวลา'].includes(value.questiontype)">
          <div class="px-5">
            <div>Default answer</div>
            <DropdownMenu
              v-model="value.Options2"
              :options="defaultAnswerOptions2"
              :textLabel="'label'"
              :textValue="'value'"
            >
              <div style="position: relative" class="form-control">
                <input
                  :value="defaultAnswerFiltered2"
                  readonly
                  placeholder="Default answer"
                  type="text"
                  class="depainput rsu"
                  style="padding-left: 40px !important; cursor: pointer"
                />
              </div>
            </DropdownMenu>
          </div>
        </v-flex> -->
      </v-layout>
    </div>
  </div>
</template>

<script>
import Template from '../template/template.vue'
import FormitemSubquestion from './FormitemSubquestion.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import uploadalltype from '@/components/elements/uploadalltype'
import Typography from '@/components/elements/Typography.vue'
import uploadfile from '@/components/elements/uploadfiletest.vue'
import draggable from 'vuedraggable'
export default {
  components: {
    FormitemSubquestion,
    Template,
    DropdownMenu,
    uploadalltype,
    Typography,
    uploadfile,
    draggable: {
      extends: draggable,
      inject: ['$validator']
    }
  },
  props: {
    // Options: [],
    value: {
      default: null
    },
    formlength: { default: null },
    dataindex: { default: null }
  },
  inject: ['$validator'],
  data() {
    return {
      rowCount: '',
      columnCount: '',
      tableData: [],
      morefield_input: '',
      menu: false,
      subquestionDialog: false,
      nativecheckbox: this.value.isRequired,
      digitPosition: this.value.digitPosition,
      input: {
        hideFromMember: false,
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [],
        isRequired: false,
        isMultiple: false,
        Options: '',
        digitPosition: 0,
        filename: '',
        defaultOptions: []
      },
      inputsubquestion: {
        hideFromMember: false,
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [],
        isRequired: false,
        isMultiple: false,
        Options: '',
        digitPosition: 0,
        filename: '',
        defaultOptions: []
      },
      defaultDateOptions: [
        { label: 'วันที่และเวลา', value: 'all' },
        { label: 'วันที่', value: 'date' },
        { label: 'เวลา', value: 'time' }
      ],
      defaultAnswerOptions2: [
        { label: 'None', value: '' },
        { label: 'Current Date - วันที่ปัจจุบัน', value: 'current_date' }
      ],
      defaultAnswerOptions: [
        { label: '(ไม่มี)', value: '' },
        { label: 'ชื่อ', value: 'name' },
        { label: 'อีเมล', value: 'email' },
        { label: 'เบอร์โทรศัพท์', value: 'phone_number' },
        { label: 'หมายเลขบัตรประชาชน', value: 'id_card' },
        { label: 'เลขทะเบียนนิติบุคคล', value: 'id_card2' },
        { label: 'เลขประจำตัวผู้เสียภาษีอากร', value: 'id_card3' },
        { label: 'ทุนจดทะเบียน', value: 'regis_cap' },
        { label: 'ประเภทนิติบุคคล', value: 'membertype' },
        { label: 'Project Name', value: 'project_name' },
        { label: 'Member Type', value: 'membertype2' },
        { label: 'DP Status', value: 'dptype' },
        { label: 'Register Capital', value: 'RegisterCapital' },
        { label: 'Paid Register Capital', value: 'PaidRegisterCapital' },
        { label: 'เลขเกษตรกร', value: 'farmer_number' },
        { label: 'Member ID', value: 'u_memberid' },
        { label: '[Tech hunt] รหัสคูปอง (voucher)', value: 't_product_voucher' },
        { label: '[Tech hunt] ชื่อร้านค้า (DP) ', value: 't_shop_name' },
        { label: '[Tech hunt] ชื่อสินค้า', value: 't_product' },
        { label: '[Tech hunt] ประเภทสินค้า', value: 't_product_type' },
        { label: '[Tech hunt] หมวดหมู่สินค้า', value: 't_product_category' },
        { label: '[Tech hunt] member id ของ DP', value: 'shop_memberid' },
        { label: '[Tech hunt] เลขทะเบียนนิติบุคคลของ DP', value: 'shop_juristic_id' },
        { label: '[Tech hunt] หน่วยร่วม', value: 'agency' }
      ],
      optionsStatus: [
        'ข้อความ',
        'หลายตัวเลือก',
        'เลื่อนลง',
        'ช่องทำเครื่องหมาย',
        'อัปโหลดไฟล์',
        'วัน/เวลา',
        'บทความ',
        'อัปโหลดลายเซ็น',
        'ที่อยู่',
        'ตัวเลข',
        'ตัวอย่างไฟล์',
        'ตาราง',
        'แนบลิงก์',
        'ช่องกรอกลิงก์',
        'รูปภาพ',
        'รายการผลิตภัณฑ์',
        'หน้าถัดไป'
      ],
      currentKeySub: 0
    }
  },
  computed: {
    // optionsData: {
    //   get() {
    //     return Options
    //   },
    //   set(val) {
    //     this.$emit('update:Options', val)
    //   }
    // },
    defaultDateFiltered() {
      if (this.value.Options) {
        return this.defaultDateOptions.find(el => el.value == this.value.Options).label
      } else return ''
    },
    defaultAnswerFiltered() {
      if (this.value.Options) {
        return this.defaultAnswerOptions.find(el => el.value == this.value.Options).label
      } else return ''
    },
    defaultAnswerFiltered2() {
      if (this.value.Options2) {
        return this.defaultAnswerOptions2.find(el => el.value == this.value.Options2).label
      } else return ''
    }
  },
  mounted() {},
  methods: {
    dropSubFormItem(data) {
      console.log(this.formitems)
    },
    generateTable() {
      const rows = Number(this.rowCount)
      const columns = Number(this.columnCount)
      if (rows > 0 && columns > 0) {
        this.value.formTable.data = []
        for (let i = 0; i < rows + 1; i++) {
          const rowData = []
          for (let j = 0; j < columns + 1; j++) {
            if (i === 0 && j === 0) {
              rowData.push('แสดงชื่อแถว')
            } else if (i === 0) {
              rowData.push(`คอลัมน์ ${j}`)
            } else if (j === 0) {
              rowData.push(`แถว ${i}`)
            } else {
              rowData.push('')
            }
          }
          this.value.formTable.data.push(rowData)
          // this.value.formTable = this.tableData
          // console.log(this.tableData)
        }
      }
    },
    setViewTableColumn() {
      this.value.formTable.viewColumn = !this.value.formTable.viewColumn
    },
    addRow() {
      let newRow = []
      for (let i = 0; i < this.value.formTable.data.length; i++) {
        let maxlength = this.value.formTable.data.length
        if (i + 1 == maxlength) {
          let cloneRow = this.value.formTable.data[i]
          newRow = cloneRow.map((item, i) =>
            i === 0 ? (item = `แถว ${Number(this.rowCount) + 1}`) : (item = item)
          )
        }
      }
      this.rowCount = Number(this.rowCount) + 1
      this.value.formTable.data.push(newRow)
      // this.value.formTable = this.value.formTable
      console.log(newRow)
    },
    deleteRow(rowIndex) {
      if (this.value.formTable.data.length > 2) {
        this.value.formTable.data.splice(rowIndex, 1)
      }
      // this.value.formTable = this.tableData
    },
    addColumn() {
      for (let i = 0; i < this.value.formTable.data.length; i++) {
        if (i == 0) {
          this.value.formTable.data[i].push(`คอลัมน์ ${Number(this.columnCount) + 1}`)
          this.columnCount = Number(this.columnCount) + 1
        } else {
          this.value.formTable.data[i].push(``)
        }
      }
      // this.value.formTable = this.tableData
    },
    deleteColumn(columnIndex) {
      if (this.value.formTable.data[0].length > 2) {
        for (let i = 0; i < this.value.formTable.data.length; i++) {
          this.value.formTable.data[i].splice(columnIndex, 1)
        }
      }
      // this.value.formTable = this.tableData
    },
    checkFocus(idx) {
      if (this.value.fields[idx].focus != undefined) {
        this.value.fields[idx].focus = !this.value.fields[idx].focus
        for (let index = 0; index < this.value.fields.length; index++) {
          if (index != idx) {
            this.value.fields[index].focus = false
          }
        }
        this.$forceUpdate()
        console.log('มีค่า', this.value.fields[idx].focus)
      } else {
        this.value.fields[idx].focus = true
        for (let index = 0; index < this.value.fields.length; index++) {
          if (index != idx) {
            this.value.fields[index].focus = false
          }
        }
        this.$forceUpdate()
        console.log('ว่าง', this.value.fields[idx].focus)
      }
    },
    onUploadedFile(url) {
      this.update('fileurl', url)
    },
    onUploadedImg(url) {
      this.update('imgFile', url)
      console.log(this.value)
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    ondelete(index, k) {
      // @ondelete="ondelete(index, k)"
      //             v-model="value.fields[k].subquestion[index]"
      this.value.fields[k].subquestion.splice(index, 1)
    },
    addsubquestion(k, questiontype) {
      if (questiontype) {
        this.value.fields[k].subquestion.push({
          hideFromMember: false,
          name: '',
          questiontype: questiontype,
          fields: [],
          isRequired: false,
          isMultiple: false,
          Options: '',
          digitPosition: 0,
          defaultOptions: []
        })
      } else {
        this.value.fields[k].subquestion.push({
          hideFromMember: false,
          name: '',
          questiontype: 'ข้อความ',
          fields: [],
          isRequired: false,
          isMultiple: false,
          Options: '',
          digitPosition: 0,
          defaultOptions: []
        })
      }
    },
    selectOptionStatus(item) {
      this.update('questiontype', item)
      this.$nextTick(() => {
        if (item == 'วัน/เวลา') {
          this.value.Options = 'all'
        } else if (item == 'ตาราง') {
          this.rowCount = ''
          this.columnCount = ''
        } else {
          this.value.Options = ''
        }
        this.update('fields', [])
      })
    },
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    onBlurMorefield() {
      if (this.morefield_input) {
        this.value.fields.push({ label: this.morefield_input, subquestion: [] })

        this.$nextTick(() => {
          this.morefield_input = ''
        })
      }
    },
    typeIcon(item) {
      switch (item) {
        case 'ข้อความ':
          return 'textIco'
        case 'หลายตัวเลือก':
          return 'multiChoiceIco'
        case 'เลื่อนลง':
          return 'pushDownIco'
        case 'ช่องทำเครื่องหมาย':
          return 'markIco'
        case 'อัปโหลดไฟล์':
          return 'uploadFilesIco'
        case 'อัปโหลดลายเซ็น':
          return 'uploadSignIco'
        case 'หัวข้อ':
          return 'topicIco'
        case 'บทความ':
          return 'paragraphIco'
        case 'หน้าถัดไป':
          return 'nextPageIco'
        case 'วัน/เวลา':
          return 'dateTimeIco'
        case 'ที่อยู่':
          return 'addressIco'
        case 'ตัวเลข':
          return 'numericIco'
        case 'ตัวอย่างไฟล์':
          return 'previewFileIco'
        case 'ตาราง':
          return 'tableIco'
        case 'แนบลิงก์':
          return 'attachLinkIco'
        case 'ช่องกรอกลิงก์':
          return 'linkIco'
        case 'รูปภาพ':
          return 'imgIco'
        case 'รายการผลิตภัณฑ์':
          return 'productListIco'
      }
    },
    addField() {
      this.input.fields.push('')
    },
    deleteItem(k) {
      this.value.fields.splice(k, 1)
    }
  },
  watch: {},
  filters: {
    filterStatus: function(value) {
      switch (value) {
        case 'ข้อความ':
          return 'ข้อความ (text)'
        case 'หลายตัวเลือก':
          return 'หลายตัวเลือก (Multiple choice)'
        case 'ช่องทำเครื่องหมาย':
          return 'ช่องทำเครื่องหมาย (Checkboxes)'
        case 'เลื่อนลง':
          return 'เลื่อนลง (Choose from a list)'
        case 'อัปโหลดไฟล์':
          return 'อัปโหลดไฟล์ (Upload file)'
        case 'อัปโหลดลายเซ็น':
          return 'อัปโหลดลายเซ็น (Upload signature)'
        case 'หัวข้อ':
          return 'หัวข้อ (Title)'
        case 'บทความ':
          return 'บทความ (Paragraph)'
        case 'หน้าถัดไป':
          return 'หน้าถัดไป (Next page)'
        case 'วัน/เวลา':
          return 'วัน/เวลา (Date/time)'
        case 'ที่อยู่':
          return 'ที่อยู่ (Address)'
        case 'ตัวเลข':
          return 'ตัวเลข (Number)'
        case 'ตัวอย่างไฟล์':
          return 'ตัวอย่างไฟล์ (Sample file)'
        case 'ตาราง':
          return 'ตาราง'
        case 'แนบลิงก์':
          return 'แนบลิงก์'
        case 'ช่องกรอกลิงก์':
          return 'ช่องกรอกลิงก์'
        case 'รูปภาพ':
          return 'รูปภาพ'
        case 'รายการผลิตภัณฑ์':
          return 'รายการผลิตภัณฑ์'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.d-ghost {
  opacity: 0.3;
}
.generate-table-container {
  width: 100%;
  max-height: 350px;
  overflow-x: auto;
  overflow-y: auto;
}
.generate-table-container::-webkit-scrollbar {
  -webkit-appearance: none;
  background: #eeeeee;
  border-radius: 20px;
}
.generate-table-container::-webkit-scrollbar:vertical {
  width: 13px;
}

.generate-table-container::-webkit-scrollbar:horizontal {
  height: 13px;
}

.generate-table-container::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 3px solid #eeeeee;
  background-color: #0c2f53;
}
table.form-generate-table {
  table-layout: fixed;
  width: max-content;
  thead {
    tr {
      border-bottom: 1px solid #d9d9d9;
      th {
        width: 162px;
        padding: 8px 0px;
        position: relative;
        border-radius: 0px;
        background-color: #eeeeee;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      th:first-child {
        background-color: #bdbdbd;
      }
      th:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #d9d9d9;
      td {
        padding: 8px 0px;
        border-radius: 0px;
        position: relative;
        img.table-ico {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      td:first-child {
        background-color: #eeeeee;
      }
      td:not(:first-child)::after {
        content: '';
        border-left: 1px solid #d9d9d9;
        position: absolute;
        height: 50%;
        left: 0;
        top: 25%;
      }
    }
  }
}
.icoBtn {
  font-size: 16px;
  font-weight: 600;
  color: #0c2f53 !important;
  background-color: transparent !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}
.border0 {
  border: none !important;
}
.text-error {
  color: red;
}
.w95 {
  width: 95%;
}
.patternCard {
  border-radius: 8px;
  .patternCardHeader {
    background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 26px;
    cursor: pointer;
  }
  .patternCardBody {
    // background: #e6f0fb;
    border: 1px solid #beccdb;
    border-top: none;
    border-radius: 0px 0px 8px 8px;
    .patternOption {
      padding: 20px 20px 10px 20px;
      margin: 0;
      background: #e6f0fb;
    }
    .patternSingleOption {
      padding: 20px 20px 10px 20px;
      border-radius: 0px 0px 8px 8px;
      margin: 0;
      background: #e6f0fb;
    }
    .patternTopicOption {
      padding: 20px 20px 10px 20px;
      border-radius: 0px 0px 8px 8px;
      margin: 0;
      background: #ffffff;
    }
    .patternNoneOption {
      padding: 20px 20px 10px 20px;
      border-radius: 0px 0px 8px 8px;
      margin: 0;
      background: #e6f0fb;
    }
    .patternNextPageOption {
      padding: 0px 20px 10px 20px;
      border-radius: 0px 0px 8px 8px;
      margin: 0;
      background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
      opacity: 0.8;
    }
    .patternDetails {
      padding: 20px 20px 20px 20px;
      border-radius: 0px 0px 8px 8px;
      margin: 0;
      background: #ffffff;
      .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
      }
    }
    .questiontypeTopicInput,
    .questiontypeTopicInput:focus,
    .questiontypeTopicInput:hover {
      border-right: 0 !important;
      border-left: 0 !important;
      border-top: 0 !important;
      border-radius: 0;
      font-family: 'Sukhumvit Set';
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      color: #26588b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormItem.vue